// import { gsap } from 'gsap';

export default () => {
	const btn = document.querySelector('.js-breadcrumbs-toggle');
	const body = document.body;

	if (btn) {
		

		btn.addEventListener('click', (e) => {
			body.classList.toggle('is-breadcrumbs-open');
		});

		document.addEventListener('click', (e) => {
			if (e.target.closest('.js-close-breadcrumbs')) {
				body.classList.remove('is-breadcrumbs-open');
			}
		});
	}
};